(function () {
  'use strict';

  const DESKTOP_MQ = '(min-width: 996px)';
  let resizeTimer = null;

  function clearHeights(elements) {
    elements.forEach(function (el) {
      el.style.minHeight = '';
      el.style.height = '';
    });
  }

  function equalizeGroup(elements) {
    if (!elements.length) return;

    clearHeights(elements);

    let maxHeight = 0;
    elements.forEach(function (el) {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    if (maxHeight <= 0) return;

    elements.forEach(function (el) {
      el.style.minHeight = maxHeight + 'px';
    });
  }

  function groupCardsByRow(cards) {
    const rowMap = {};

    cards.forEach(function (card) {
      const top = Math.round(card.getBoundingClientRect().top);
      if (!rowMap[top]) rowMap[top] = [];
      rowMap[top].push(card);
    });

    return rowMap;
  }

  function equalNotesLineHeight() {
    const sections = document.querySelectorAll('.mycard-1-section');
    const isDesktop = window.matchMedia(DESKTOP_MQ).matches;

    sections.forEach(function (section) {
      section.querySelectorAll('.mycard-1-body .description').forEach(function (el) {
        el.style.height = '';
        el.style.minHeight = '';
      });

      const cards = Array.prototype.slice.call(section.querySelectorAll('.col-three'));
      const mediaBlocks = Array.prototype.slice.call(section.querySelectorAll('.mycard-1'));
      const notesLines = Array.prototype.slice.call(section.querySelectorAll('.notes-line'));

      if (!isDesktop) {
        clearHeights(mediaBlocks);
        clearHeights(notesLines);
        return;
      }

      if (!cards.length) return;

      // Pass 1: equalize image blocks per row so notes start on one line
      clearHeights(mediaBlocks);
      let rowMap = groupCardsByRow(cards);
      Object.keys(rowMap).forEach(function (top) {
        const media = rowMap[top]
          .map(function (card) {
            return card.querySelector('.mycard-1');
          })
          .filter(Boolean);
        equalizeGroup(media);
      });

      // Pass 2: equalize notes-line per row after image heights settle
      rowMap = groupCardsByRow(cards);
      Object.keys(rowMap).forEach(function (top) {
        const notes = rowMap[top]
          .map(function (card) {
            return card.querySelector('.notes-line');
          })
          .filter(function (el) {
            return el && el.children.length;
          });
        equalizeGroup(notes);
      });
    });
  }

  function runEqualize() {
    window.requestAnimationFrame(function () {
      equalNotesLineHeight();
      // Second frame catches late image/font layout
      window.requestAnimationFrame(equalNotesLineHeight);
    });
  }

  function scheduleEqualize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runEqualize, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runEqualize);
  } else {
    runEqualize();
  }

  window.addEventListener('resize', scheduleEqualize);
  window.addEventListener('load', runEqualize);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(runEqualize).catch(function () {});
  }

  document.addEventListener('shopify:section:load', runEqualize);
  document.addEventListener('shopify:section:reorder', runEqualize);
})();
